/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Col_RetriesInputs */

const en_fw_bm_col_retries = /** @type {(inputs: Fw_Bm_Col_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retries`)
};

const id_fw_bm_col_retries = /** @type {(inputs: Fw_Bm_Col_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulang`)
};

/**
* | output |
* | --- |
* | "Retries" |
*
* @param {Fw_Bm_Col_RetriesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_col_retries = /** @type {((inputs?: Fw_Bm_Col_RetriesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Col_RetriesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_col_retries(inputs)
	return en_fw_bm_col_retries(inputs)
});